module.exports = __webpack_public_path__ + "img/list-white.3e2fdc4d.svg";